import { Map } from "immutable";

import { actionTypes } from "./actions";

const reducer = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_CHARACTER_WIDTHS:
      return state.merge(action.widthMap);
    default:
      return state;
  }
};

export default reducer;
